import { useEffect, useCallback } from 'react';

export const useCMDEnterKeys = (handleClose, actionIsEnabled) => {
  const handleCMDEnter = useCallback(
    (event) => {
      if (event.metaKey && event.key === 'Enter' && actionIsEnabled) {
        event.preventDefault();
        handleClose();
      }
    },
    [handleClose, actionIsEnabled]
  );
  useEffect(() => {
    window.addEventListener('keydown', handleCMDEnter);

    return () => {
      window.removeEventListener('keydown', handleCMDEnter);
    };
  }, [handleCMDEnter]);
};
